/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
// eslint-disable-next-line import/order
import React from 'react';

import { Typography } from 'tfc-components';

import Section from 'components/organisms/Section';

const Banner:React.FC = () => (
  <Section className="p-about_banner">
    <Section.Title white className="p-about_banner_headTitle">
      About EVOL LABS
    </Section.Title>
    <Typography.Text extendClasses="f-20x24 p-about_banner_title">
      Where Bold Ideas Meet Real Impact
    </Typography.Text>

  </Section>
  );

export default Banner;
